import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { usePageTitle } from "@/lib/usePageTitle";

export default function AdminLogin() {
  usePageTitle("Admin | Mentheris");
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-line focus:border-ink outline-none py-3 text-base placeholder:text-fog/60 transition-colors duration-300";

  return (
    <main className="min-h-screen flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <p className="font-serif text-3xl mb-2">Mentheris<span className="text-ember">.</span></p>
        <p className="text-xs tracking-[0.25em] uppercase text-fog mb-10">Admin access</p>
        <form onSubmit={submit} className="space-y-8" data-testid="admin-login-form">
          <input
            data-testid="admin-email-input"
            type="email"
            className={inputCls}
            placeholder="Email"
            required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <input
            data-testid="admin-password-input"
            type="password"
            className={inputCls}
            placeholder="Password"
            required
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
          {error && (
            <p className="text-sm text-ember" data-testid="admin-login-error">{error}</p>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="w-full border border-ink px-8 py-4 text-sm tracking-wide hover:bg-ink hover:text-bone transition-colors duration-300 disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </main>
  );
}
